import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { CloneSurveyRPC } from "./cloneSurveyRPC";

export class CloneSurveyRPCClientImpl extends CloneSurveyRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: CloneSurveyRPC.Request): Promise<LeoRPCResult<CloneSurveyRPC.Response, CloneSurveyRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "survey/CloneSurvey",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      CloneSurveyRPC.ResponseDTO,
      CloneSurveyRPC.Errors.ErrorsDTO,
      CloneSurveyRPC.Response,
      CloneSurveyRPC.Errors.Errors
    >(
      response,
      "survey/CloneSurvey",
      CloneSurveyRPC.Response.fromDTO,
      CloneSurveyRPC.Errors.fromDTO
    );
  }
}
